import { SimpleFirmwareImage } from './state/SimpleTomFirmwareState.ts';

export function getVersionString(image: SimpleFirmwareImage): string {
    return [image.versionMajor, image.versionMinor, image.versionRevision].join(
        '.',
    );
}
